import type { AccountingUnit } from '../../types/accounting-levels';

/**\n * Valide une unité comptable\n * company (niveau 0) n'a pas besoin de parentId\n * branch et pos (niveaux 1 et 2) doivent avoir un parentId\n */
export const validateUnit = (unit: Partial<AccountingUnit>): boolean => {
  if (!unit.name?.trim() || !unit.code?.trim()) {
    return false;
  }

  // company n'a pas besoin de parent, mais branch et pos oui
  if (unit.type !== 'company' && !unit.parentId) {
    return false;
  }

  return true;
};

export const validateUnitCode = (code: string, existingUnits: AccountingUnit[]): boolean => {
  return !existingUnits.some(unit => unit.code === code);
};